import {
    useEffect,
    useRef
} from "react";
import {
    Animated,
    Platform
} from "react-native";
import type {
    MotionIntentType,
    MotionType
} from "./timing";
import useMotionTiming, {
    type MotionThemeType
} from "./useMotionTiming";

export type AnimatedStateConstantType = {
    isNativeDriverEnabled?: boolean;
    customTheme?: MotionThemeType;
    intent: MotionIntentType;
    onFinish?: () => void;
    motion?: MotionType;
    value: number;
};

const useAnimatedState = ({
    isNativeDriverEnabled = true,
    customTheme,
    onFinish,
    intent,
    motion,
    value
}: AnimatedStateConstantType): Animated.Value => {
    const animatedValue = useRef(new Animated.Value(value)).current;

    const isMountedRef = useRef(false);

    const onFinishRef = useRef(onFinish);

    const {
        duration,
        easing
    } = useMotionTiming(intent, customTheme, motion);

    onFinishRef.current = onFinish;

    useEffect(() => {
        if(!isMountedRef.current) {
            isMountedRef.current = true;

            return;
        }

        const animation = Animated.timing(animatedValue, {
            useNativeDriver: isNativeDriverEnabled && Platform.OS !== "web",
            toValue: value,
            duration,
            easing
        });

        animation.start(({
            finished
        }) => {
            if(finished) {
                onFinishRef.current?.();
            }
        });

        return () => {
            animation.stop();
        };
    }, [
        value
    ]);

    return animatedValue;
};
export default useAnimatedState;
